// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root___qL3A","content":"LoadingAlert_content__2wW4k"};